// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"8742ec65","216":"93ad3d53","375":"e2118d30","708":"69867105","887":"d232aa62","900":"6a8c77ea","992":"7b406c0c"}[chunkId] + ".chunk.js";
};